import { ca } from '@cian/analytics';

export function trackingFavoritesItemClick(offerId: number, index: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'to_card',
    label: 'favorites_popup',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: index + 1,
      },
    ],
  });
}

export function trackingFavoritesItemShow(offerId: number, position: number) {
  ca('teaser', {
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position: position + 1,
      screen: '',
      block: 'FavoritesHeart',
    },
  });
}
